import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonService from "../../services/common.service";
import { API_URLS } from "../../constants/api-urls";
import { unwrapApiData } from "./cm/cmProductionPaths";

/**
 * Ensures CM purchase order exists, then opens the standard Generate Invoice screen
 * with the correct PO id (Contract Manufacturing production flow).
 */
export default function SellerCmProductionInvoicePage() {
  const { rfqId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await CommonService.post(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT_ENSURE_PO(rfqId), {});
        const res = await CommonService.get(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT(rfqId));
        const data = unwrapApiData(res);
        const poId = data?.purchaseOrderId;
        const existingInvoiceId = data?.invoice?.id;
        if (!poId) {
          throw new Error("Purchase order could not be created for this RFQ.");
        }
        if (!cancelled) {
          navigate("/generate-invoice", {
            replace: true,
            state: { poId, invoiceId: existingInvoiceId || undefined, cmRfqId: Number(rfqId) },
          });
        }
      } catch (e) {
        const m = e?.response?.data?.message || e?.message || "Failed to open invoice";
        toast.error(m);
        if (!cancelled) navigate("/seller/cm-rfqs", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [rfqId, navigate]);

  return (
    <div className="container py-5">
      <p className="text-muted mb-0">Preparing invoice workspace…</p>
    </div>
  );
}
